import PropTypes from "prop-types";

const Label = ({ children, required, ...props }) => {
    return (
        <div style={{fontSize: "16px", fontWeight: '500', marginBottom: '5px', display: 'flex', alignItems: 'center', gap: '5px'}} {...props}>
            {required && <span style={{ color: "white", fontSize: "20px", lineHeight: '24px', display: 'inline-flex', height: '15px', width: '15px', justifyContent: 'center', alignItems: 'unset', background: 'red' }}>*</span>} {children} 
        </div>
    );
};

// Set default props
Label.defaultProps = {
    required: false, // Default is false
};

// Validate prop types
Label.propTypes = {
    children: PropTypes.node.isRequired, // Children must be provided
    required: PropTypes.bool, // `required` is a boolean
};

export default Label;
